document.querySelectorAll('.card').forEach((card) => card.addEventListener("click", () => {
    if(card.classList.contains("active")) {
        card.classList.add("active");
    }
    else {
        document.querySelectorAll(".card").forEach(card => card.classList.remove("active"));

        card.classList.add("active");
    }
}));